import styled from "styled-components";
import BreakPointsFontsMedia from "../../utils/BreakPointsFontsMedia";
import DS from "../DS";
import {
  BaseTypoCSS,
  BaseTypoProps,
} from "./BaseTypo";

const SubTitle1 = styled.p<BaseTypoProps>`
  ${BaseTypoCSS({
    fontFamily: "NeueHaasUnica",
  })}
  font-style: normal;
  font-size: 16px;
  line-height: 21px;
  letter-spacing: 0;
  font-weight: 500;
  ${BreakPointsFontsMedia(
    DS.breakpoints,
    22,
    16,
    5
  )};
`;

export default SubTitle1;
